import { BookOpenText } from "lucide-react";

/** Decorative line art, not a ritual diagram or a replacement for the Mission emblem. */
export function Lotus({ className = "" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 120 90" fill="none" stroke="currentColor" strokeWidth="1.2" aria-hidden="true">
      <path d="M60 72C32 55 39 26 60 7c21 19 28 48 0 65Z" />
      <path d="M60 72C28 72 13 48 17 23c27 4 44 20 43 49Zm0 0c32 0 47-24 43-49-27 4-44 20-43 49Z" />
      <path d="M60 72C27 89 6 64 4 46c21-1 41 8 56 26Zm0 0c33 17 54-8 56-26-21-1-41 8-56 26Z" />
      <path d="M35 84h50M60 72V31" />
    </svg>
  );
}

/** CSS book construction adapted from BIVR's BookShowcase, with Mission-specific artwork. */
export function ReadingCover({ title, category }: { title: string; category: string }) {
  const tone = category === "Darśana" ? "sage" : category === "Śrīvidyā" ? "saffron" : "wine";
  return (
    <div className={`reading-art reading-art--${tone}`} aria-hidden="true">
      <Lotus className="reading-art-lotus" />
      <div className="reading-cover">
        <span className="reading-cover-series">Sri Devinatha Mission</span>
        <BookOpenText strokeWidth={1} />
        <span className="reading-cover-title">{title}</span>
        <span className="reading-cover-category">{category}</span>
      </div>
      <span className="reading-art-label">Teachings & reflections</span>
    </div>
  );
}
